import { TableEmptyResults, TableErrorState } from '@crehana/compass.ui/table';
import { clsx } from 'clsx';
import { PREVIEW_TABLE } from '../../../constants';
import type { TVacanciesCardContentProps } from './types';
import { VacancyCard } from './vacancy-card';

export const VacanciesCardContent: React.FC<TVacanciesCardContentProps> = ({
  data,
  loading,
  error,
  search,
  pageSize,
  color,
  previewType,
  onRefetch,
  cardBackgroundClassName,
}) => {
  if (error && !loading) {
    return (
      <div
        className={clsx(
          'tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-bg-neutral-light-100',
          cardBackgroundClassName,
        )}
      >
        <TableErrorState pageSize={pageSize} onClickTryAgain={onRefetch} />
      </div>
    );
  }

  if (loading) {
    return (
      <div
        className={clsx(
          'tw-flex tw-w-full tw-justify-center tw-items-center tw-h-[40vh]',
          cardBackgroundClassName,
        )}
      >
        <div className="tw-animate-spin tw-rounded-full tw-h-8 tw-w-8 tw-border-b-2 tw-border-primary-light-500" />
      </div>
    );
  }

  if (!data?.length) {
    return (
      <div
        className={clsx(
          'tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center',
          cardBackgroundClassName,
        )}
      >
        <TableEmptyResults searchKey={search} pageSize={pageSize} />
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'tw-grid tw-gap-2 tw-w-full tw-overflow-x-hidden',
        (previewType === PREVIEW_TABLE.DESKTOP || !previewType) &&
          'sm:tw-grid-cols-1 lg:tw-grid-cols-3',
        previewType === PREVIEW_TABLE.MOBILE && 'tw-grid-cols-1',
      )}
    >
      {data.map((row, index) => (
        <VacancyCard key={row.id || index} row={row} color={color} />
      ))}
    </div>
  );
};
